import { useQuery } from '@tanstack/react-query';
import { ArrowRight, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { wikiApi } from '@/api';
import { Card, CardContent } from '@/components/ui/card';

export function WikiPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['wiki'],
    queryFn: wikiApi.list,
    staleTime: 60_000,
  });

  return (
    <div className="mx-auto max-w-7xl px-6 py-12 lg:px-12">
      <div className="mb-3 flex items-center gap-3">
        <BookOpen className="h-8 w-8 text-eol-pink" />
        <h1 className="text-3xl font-extrabold text-eol-white md:text-4xl">Вики сервера</h1>
      </div>
      <p className="mb-8 max-w-2xl text-eol-desc">
        Полезные материалы, механики и подсказки для игры на сервере.
      </p>

      {isLoading ? (
        <p className="text-eol-desc">Загрузка…</p>
      ) : isError ? (
        <p className="text-eol-desc">Не удалось загрузить вики.</p>
      ) : !data?.length ? (
        <p className="text-eol-desc">Статьи вики ещё не добавлены.</p>
      ) : (
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {data.map((article) => (
            <Link key={article.id} to={`/wiki/${article.slug}`} className="group block h-full">
              <Card className="h-full overflow-hidden transition duration-200 group-hover:-translate-y-1 group-hover:border-eol-pink/25 group-hover:shadow-[0_16px_40px_rgba(0,0,0,0.28)]">
                {article.imageUrl ? (
                  <img
                    src={article.imageUrl}
                    alt=""
                    loading="lazy"
                    className="aspect-video w-full object-cover"
                  />
                ) : (
                  <div className="flex aspect-video items-center justify-center bg-gradient-to-br from-eol-pink/20 via-eol-black to-eol-red/20">
                    <BookOpen className="h-12 w-12 text-eol-pink/70" />
                  </div>
                )}
                <CardContent className="p-5">
                  <h2 className="text-xl font-bold text-eol-white transition group-hover:text-eol-pink">
                    {article.title}
                  </h2>
                  <p className="mt-2 line-clamp-3 text-sm leading-6 text-eol-desc">
                    {article.summary}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-eol-pink">
                    Читать статью
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
